export default __webpack_public_path__ + "static/media/crea-logo.db5919ff.svg";